import { render, staticRenderFns } from "./FeatureListItem.vue?vue&type=template&id=f4a83c36&scoped=true&"
import script from "./FeatureListItem.vue?vue&type=script&lang=ts&"
export * from "./FeatureListItem.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureListItem.vue?vue&type=style&index=0&id=f4a83c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a83c36",
  null
  
)

export default component.exports